<p><b>Обычный</b></p>
<div class="box">
    <form [formGroup]="form">
        <pa-input formControlName="counter" [maxLength]="20"></pa-input>
    </form>
</div>

<p><b>Подсказки</b></p>
<div class="box">
    <form [formGroup]="form">
        <pa-input
            tooltip="Текст подсказки"
            placeholder="Placeholder"
            label="Имя пользователя" 
            formControlName="counter" 
            hint="Введите своё имя пользователя, чтобы изменить пароль."></pa-input>
    </form>
</div>

<p><b>Неверный</b></p>
<div class="box">
    <form [formGroup]="form3">
        <pa-input
            placeholder="Заполните поле"
            label="Имя пользователя" 
            formControlName="counter" 
            hint="Введите своё имя пользователя, чтобы изменить пароль."
            [maxLength]="100"></pa-input>
    </form>
</div>

<p><b>Выключенный</b></p>
<div class="box">
    <form [formGroup]="form2">
        <pa-input 
            label="Имя пользователя" 
            formControlName="counter"></pa-input>
    </form>
</div>

<p><b>Левая иконка</b></p>
<div class="box">
    <form [formGroup]="form">
        <pa-input 
            icon="pi-search"
            label="Имя пользователя" 
            formControlName="counter"></pa-input>
    </form>
</div>

<p><b>Выключенный левая иконка</b></p>
<div class="box">
    <form [formGroup]="form2">
        <pa-input 
            icon="pi-search"
            label="Имя пользователя" 
            formControlName="counter"></pa-input>
    </form>
</div>


<p><b>Маска</b></p>
<div class="box">
    <form [formGroup]="form">
        <pa-input
            label="Имя пользователя" 
            formControlName="counter"
            [mask]="'9999999'"></pa-input>
    </form>
</div>


<p><b>Валютный</b></p>
<div class="box">
    <form [formGroup]="form">
        <pa-input
            placeholder="0,00 ₽"
            label="Введите сумму" 
            formControlName="counter"
            [currency]="'rub'"></pa-input>
    </form>
</div>

<p><b>Кастомные сообщения ошибок</b></p>
<div class="box">
    <form [formGroup]="form4">
        <pa-input
            placeholder="Введите текст"
            label="Имя пользователя"
            formControlName="counter"
            [customErrorMessages]="customErrorMessages"
        ></pa-input>
    </form>
</div>

<hr>
<h3>Поле ввода телефона (pa-input-phone)</h3>

<p><b>Обычный</b></p>
<div class="box">
    <form [formGroup]="phoneForm1">
        <pa-input-phone formControlName="phone"></pa-input-phone>
    </form>
</div>

<p><b>С подсказками и кастомным placeholder</b></p>
<div class="box">
    <form [formGroup]="phoneForm1">
        <pa-input-phone
            label="Номер телефона"
            placeholder="+7 (___) ___-__-__"
            hint="Введите номер телефона в российском формате"
            tooltip="Номер телефона должен начинаться с +7"
            formControlName="phone"
        ></pa-input-phone>
    </form>
</div>

<p><b>С валидацией (обязательное поле)</b></p>
<div class="box">
    <form [formGroup]="phoneForm2">
        <pa-input-phone
            label="Контактный телефон"
            hint="Телефон обязателен для регистрации"
            formControlName="phone"
        ></pa-input-phone>
    </form>
</div>

<p><b>Выключенный (с предзаполненным значением)</b></p>
<div class="box">
    <form [formGroup]="phoneForm3">
        <pa-input-phone
            label="Телефон (неактивный)"
            formControlName="phone"
        ></pa-input-phone>
    </form>
</div>

<p><b>С предзаполненным значением</b></p>
<div class="box">
    <form [formGroup]="phoneForm4">
        <pa-input-phone
            label="Ваш телефон"
            formControlName="phone"
        ></pa-input-phone>
    </form>
</div>

<hr>
<h3>Поле ввода кода (pa-input-otp)</h3>

<p><b>Обычный</b></p>
<div class="box">
    <form [formGroup]="otpForm">
        <pa-input-otp formControlName="code"></pa-input-otp>
    </form>
</div>

<p><b>С ошибкой</b></p>
<div class="box">
    <form [formGroup]="otpErrorForm">
        <pa-input-otp
            formControlName="code"
            [invalid]="true"
            errorText="Неверный код подтверждения."
        ></pa-input-otp>
    </form>
</div>

<p><b>Выключенный</b></p>
<div class="box">
    <form [formGroup]="otpDisabledForm">
        <pa-input-otp formControlName="code"></pa-input-otp>
    </form>
</div>